import { Frame } from '../../../services';

export interface HeaderNode {
  header: string;
  value: string;
}

export interface TableContentNode {
  [id: string]: string;
}

export interface JsonImgNode {
  caption?: string;
  value: string;
}

export interface ImageCarouselContentNode {
  type: string;
  value: JsonImgNode;
}

export interface VideoNode {
  url: string;
  frames?: Frame[];
}

export enum JsonContentType {
  br = 'br',
  hr = 'hr',
  headerValue = 'headerValue',
  header = 'header',
  iframe = 'iframe',
  table = 'table',
  text = 'text',
  url = 'url',
  imageCarousel = 'imageCarousel',
  imageUrl = 'imageUrl',
  sectionHeader = 'sectionHeader',
  imageBytes = 'imageBytes',
  video = 'video',
  audioUrl = 'audioUrl',
  unknown = 'unknown'
}

export interface JsonBaseNode {
  type: JsonContentType;
}

export interface JsonContentTypeUnknown {
  type: JsonContentType.unknown;
}
export interface JsonContentTypeBlank extends JsonBaseNode {
  type: JsonContentType.br | JsonContentType.hr;
}

export interface JsonContentTypeString extends JsonBaseNode {
  type:
    | JsonContentType.header
    | JsonContentType.iframe
    | JsonContentType.url
    | JsonContentType.sectionHeader
    | JsonContentType.text;
  value: string;
}

export interface JsonContentTypeHeaderValue extends JsonBaseNode {
  type: JsonContentType.headerValue;
  value: HeaderNode;
}

export interface JsonContentTypeTable extends JsonBaseNode {
  type: JsonContentType.table;
  value: TableContentNode[];
}

export interface JsonContentTypeImageCarousel extends JsonBaseNode {
  type: JsonContentType.imageCarousel;
  value: ImageCarouselContentNode[];
}

export interface JsonContentTypeVideo extends JsonBaseNode {
  type: JsonContentType.video;
  value: VideoNode;
}

export interface JsonContentTypeImageUrl extends JsonBaseNode {
  type: JsonContentType.imageUrl | JsonContentType.imageBytes | JsonContentType.audioUrl;
  value: JsonImgNode;
}

export type JsonContentNode =
  | JsonContentTypeBlank
  | JsonContentTypeString
  | JsonContentTypeHeaderValue
  | JsonContentTypeTable
  | JsonContentTypeImageCarousel
  | JsonContentTypeVideo
  | JsonContentTypeUnknown
  | JsonContentTypeImageUrl;

export interface JsonContent {
  output: JsonContentNode[];
}
